/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectImageReference } from '../../models/project-image-reference';

export interface GetProjectImageReference$Params {
  projectId: string;
  id: string;
}

export function getProjectImageReference(http: HttpClient, rootUrl: string, params: GetProjectImageReference$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectImageReference>> {
  const rb = new RequestBuilder(rootUrl, getProjectImageReference.PATH, 'get');
  if (params) {
    rb.path('projectId', params.projectId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectImageReference>;
    })
  );
}

getProjectImageReference.PATH = '/project/{projectId}/images/{id}';
